import request from '@/utils/request'

export function confirmationEmail(data) {
  return request({
    url: '/sendGrid/confirmationEmail',
    method: 'post',
    data
  })
}

